import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import { withPrefix } from "gatsby";
import img1 from "../../../../src/visuals/design/L2_visual_5_1_do.png";
import img2 from "../../../../src/visuals/design/L2_visual_5_1_dont.png";
import img3 from "../../../../src/visuals/design/L2_visual_5_2_eg.png";
import img4 from "../../../../src/visuals/design/L2_visual_5_3_eg.png";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  withPrefix,
  img1,
  img2,
  img3,
  img4,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};